$(document).ready(function () {
  

  
  //pagina de producto
  if( $("body").hasClass("templateProduct") ){
  	
      $(".qty-inner .qty-up").on("click", function() {
              	var oldValue = $("#quantity").attr('value');
				var newVal = 1;
        		newVal = parseInt(oldValue) + 1;
        		$("#quantity").attr('value',newVal);
          });

      $(".qty-inner .qty-down").on("click", function() {
        	var newVal=1;
        	var oldValue = $("#quantity").attr('value');
        	var minValue = $("#quantity").attr('min');
        	if (oldValue > 1) {
                if(oldValue > minValue){
                  newVal = 1;
                  newVal = parseInt(oldValue) - 1;
                  $("#quantity").attr('value',newVal);
                  console.log($("#quantity").attr('value'));  
                }

              }
      });
    
    $("#add-to-cart").on("click", function(){
		       window.stop();
	    var minValue = $("#quantity").attr('min');
      	var Pedidovalue= $("#quantity").attr('value');

      	if(parseInt(Pedidovalue) < parseInt(minValue))
        {
                   
			    	alert("error");          
        	$("#quantity").attr('value',minValue);

        }
    });	
    
    	   
    
}
    
   
    
//pagina de carrito
  if( $("body").hasClass("templateCart") ){
    	
  	
    	$('.cart-item .item-qty div input').each(function( index ) {
          	//$( this ).attr('min',$( this ).attr('value'));
        });
    	
      
  
  }
  
});







              


